import parseApiV1DoctorLocationTimes from './parseApiV1DoctorLocationTimes';

/**
 * @param {object} response
 */
function parseApiV1Response(response) {
    const doctorLocations = {};

    if (response) {
        response.doctor_locations.forEach(doctorLocation => {
            doctorLocations[doctorLocation.id] = parseApiV1DoctorLocationTimes(doctorLocation);
        });
    }

    return doctorLocations;
}

export default parseApiV1Response;
